module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij48cGF0aCBkPSJNOS45OTMsM0E3LDcsMCwxLDAsMTcsMTAsNyw3LDAsMCwwLDkuOTkzLDNaTTEwLDE1LjZBNS42LDUuNiwwLDEsMSwxNS42LDEwLDUuNiw1LjYsMCwwLDEsMTAsMTUuNlptLjM1LTkuMUg5LjN2NC4yTDEyLjk3NSwxMi45bC41MjUtLjg2MS0zLjE1LTEuODY5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMgLTMpIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sportlife/icono-fecha.svg
// module id = f6Wb
// module chunks = 3